

import React from 'react';
import {login} from 'account-portal-library/lib/appleSignIn';
import AppVars from '../../../../AppVars.js';
import Logger from '../../../../Logger.js';
import Loader from '../../../Loader';


const logger = Logger.getInstance();
const appVars = AppVars.getInstance();

class AppleButton extends React.Component {
    constructor(props){
    super(props);
    this.handleAppleLogin = this.handleAppleLogin.bind(this);
    this.state = {...props}
    }

    async handleAppleLogin(){
        logger.log('test', 'style: ' + sessionStorage.AP_STYLE)
        await login(sessionStorage.AP_STYLE, appVars.getBaseUrl(), appVars.getRealm(), appVars.getAppleSignInTree(), appVars.getDomain(), appVars.getName())
    }

    render(){
        if (this.props.implicitRegister) {
            this.handleAppleLogin();
            return (
                <Loader />
            )
        } else {
            return(
                <button alt="Continue With Apple" onClick={this.handleAppleLogin} className="button-box-apple">
                <span className = "button-text button-text-apple">Continue with Apple</span></button>
                // <img alt="Sign In with Apple" onClick={this.handleAppleLogin} src={AppleButtonImg} className="button-apple button-social"/>
            )
        }
    }
}

export default AppleButton;